<template>
  <div class="home-button-container">
      <button class="home-button-content" @click="home">
      </button>
  </div>
</template>

<script>
export default {
  name: 'HomeButton',
  components: {},
  props: {},
  data() {
    return  {};
  },
  methods: {
    home:function (){
      this.$router.push({
        path: '/mainPage',
      })
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped>
.home-button-content{
  background-image: url("../assets/image/homeButton/HomeButton.png");
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  background-color: transparent;
  border: 0;
}

.home-button-container{
  width: 15vw;
  height: 15vw;
  top: 8vw;
  right: 9vw;
  position: absolute;
}
</style>
